import Vue from 'vue'
import XzdListPage from "@/components/xzd/listPage/XzdListPage";
import ShowSpace from '@/components/ShowSpace/index'
import ColorPicker from '@/components/ColorPicker/index'

Vue.component('XzdListPage', XzdListPage)
Vue.component('ShowSpace', ShowSpace)
Vue.component('ColorPicker', ColorPicker)